import { FC } from 'react'

import { SurveyResponseID } from '@forto-dev/notification-center-models'
import { Button, ButtonProps, Cluster, Icon, IconName, Typography } from '@forto-dev/phoenix-ui-core'

import { SurveyQuestionProps, SurveyQuestionStatus } from '../domain/survey/surveyQuestionProps'
import { useRenderSurveyText } from '../hooks/survey/useRenderSurveyText'

const buttonConfig: Partial<Record<SurveyResponseID, { icon?: IconName } & Pick<ButtonProps, 'variant'>>> = {
  useful: { icon: 'ThumbsUp', variant: 'primary' },
  not_useful: { icon: 'ThumbsDown', variant: 'outline-primary' },
}

export const InlineButtonSurveyQuestion: FC<SurveyQuestionProps> = ({ question, onChange }) => {
  const { render } = useRenderSurveyText()
  return (
    <Cluster gap={16} y="center">
      <Typography variant="body">{render(question)}</Typography>

      <Cluster gap={8} breakpoint="sm">
        {question.responses.map((response) => {
          const { icon, variant } = buttonConfig[response.id as SurveyResponseID] || { variant: 'outline-primary' }

          return (
            <Button
              key={response.id}
              size="sm"
              variant={variant}
              onClick={() => {
                onChange({
                  surveyQuestionResponse: { id: question.id, responses: [{ id: response.id }] },
                  status: SurveyQuestionStatus.answered,
                })
              }}
            >
              <Cluster y="center" gap={4}>
                {icon && <Icon name={icon} size="xs" />}
                <Typography variant="small">{render(response)}</Typography>
              </Cluster>
            </Button>
          )
        })}
      </Cluster>
    </Cluster>
  )
}
